import React, { Component } from 'react'
import { connect } from 'react-redux'
import { MultiMenuTrigger } from '@protonapp/react-multi-menu'
import { actionTypes } from '@adalo/constants'

import { getActionOptions } from 'utils/actions'

import {
  showModal,
  NEW_SCREEN_MODAL,
  NEW_TABLE,
  CUSTOM_ACTION_MODAL,
  INTEGRATION_TRIAL_MODAL,
} from 'ducks/editor/modals'

import {
  getScreens,
  getTrialInformation,
  getUpgraded,
  getApp,
} from 'ducks/apps'

import { getDatasources } from 'ducks/apps/datasources'
import { getContextualObjects } from 'ducks/recommender'
import { getCustomActions } from 'ducks/customActions'
import {
  showModal as showUpgradeModal,
  setPaymentRouteType,
} from 'ducks/trialWarning'
import { getFeatureFlag } from 'ducks/featureFlags'
import { getThirdPartyApiKeyFor } from 'ducks/thirdPartyApiKeys'

import EmptyState from 'components/Shared/EmptyState'
import Button from 'components/Shared/Button'
import Icon from 'components/Shared/Icon'

import { THEMES } from '../../../constants'

class ActionsEmptyState extends Component {
  getMenu = () => {
    const {
      datasources,
      datasourceType,
      screens,
      componentId,
      contextOptions,
      customActions,
      paying,
      isAfterTrial,
      appId,
      app,
      hasLocationDataType,
      googleApiKeyIsValid,
    } = this.props

    return getActionOptions(
      datasourceType,
      datasources,
      screens,
      componentId,
      contextOptions,
      customActions,
      paying,
      isAfterTrial,
      appId,
      app,
      hasLocationDataType,
      googleApiKeyIsValid
    )
  }

  handleSelect = async value => {
    const {
      onCreate,
      showModal,
      paying,
      isAfterTrial,
      appId,
      showUpgradeModal,
      setPaymentRouteType,
    } = this.props

    if (typeof value === 'object') {
      if (value.target === 'new') {
        try {
          value = {
            target: (await showModal(NEW_SCREEN_MODAL)).value,
          }
        } catch (err) {
          return
        }
      }

      if (value.target === 'createNewCollection') {
        try {
          value = {
            target: (await showModal(NEW_TABLE)).value,
          }

          return onCreate({
            actionType: actionTypes.CREATE_OBJECT,
            options: value.target,
          })
        } catch (err) {
          return null
        }
      }

      if (value.target === 'createNewCustomAction') {
        if (isAfterTrial && !paying) {
          try {
            await setPaymentRouteType('upgrade')
            await showUpgradeModal()

            return
          } catch (err) {
            // modal closed early
            console.error("modal closed, here's the error:", err)

            return
          }
        } else if (!paying) {
          try {
            await showModal(INTEGRATION_TRIAL_MODAL, {
              type: 'custom-actions',
              appId,
            })
          } catch (err) {
            // modal closed early
            console.error("modal closed, here's the error:", err)

            return
          }
        }

        try {
          const options = (await showModal(CUSTOM_ACTION_MODAL)).value

          return onCreate({
            actionType: actionTypes.CUSTOM,
            options: { customActionId: options },
          })
        } catch (err) {
          return null
        }
      }

      if (value?.actionType === actionTypes.CUSTOM) {
        return onCreate({
          actionType: actionTypes.CUSTOM,
          options: { customActionId: value.options.id },
        })
      }

      if (value?.actionType === actionTypes.AUTHENTICATE_EXTERNAL) {
        return onCreate({
          actionType: actionTypes.AUTHENTICATE_EXTERNAL,
          options: { customActionId: value.options.id },
        })
      }

      if (value?.actionType === actionTypes.SIGNUP_EXTERNAL) {
        return onCreate({
          actionType: actionTypes.SIGNUP_EXTERNAL,
          options: { customActionId: value.options.id },
        })
      }

      if (value?.actionType) return onCreate(value)

      return onCreate({
        actionType: actionTypes.NAVIGATE,
        options: value,
      })
    }

    onCreate({ actionType: value })
  }

  render() {
    const { children } = this.props

    return (
      <div className="empty-action-items">
        <EmptyState bordered>No Actions</EmptyState>
        <MultiMenuTrigger
          menu={this.getMenu()}
          onSelect={this.handleSelect}
          rowHeight={40}
          menuTheme={THEMES.ACTION}
        >
          {children || (
            <Button>
              <span>Add Interaction</span>
              <Icon type="expand-vertical" />
            </Button>
          )}
        </MultiMenuTrigger>
      </div>
    )
  }
}

const mapStateToProps = (
  state,
  { appId, componentId, objectId, reference }
) => {
  const { trialState } = getTrialInformation(state, appId)
  const googleApiKey = getThirdPartyApiKeyFor(state, appId, 'google')
  const googleApiKeyIsValid = googleApiKey && googleApiKey.isValid

  return {
    app: getApp(state, appId),
    screens: getScreens(state, appId),
    datasources: getDatasources(state, appId),
    contextOptions: getContextualObjects(
      state,
      appId,
      componentId,
      objectId,
      undefined,
      undefined,
      reference
    )(),
    customActions: getCustomActions(state, appId),
    paying: getUpgraded(state, appId) || trialState === 'during',
    isAfterTrial: trialState === 'after',
    hasLocationDataType: getFeatureFlag(state, 'hasLocationDataType'),
    googleApiKeyIsValid,
  }
}

export default connect(mapStateToProps, {
  showModal,
  showUpgradeModal,
  setPaymentRouteType,
})(ActionsEmptyState)
